import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0b101b] px-6 text-[#f1f5f9]" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg rounded-3xl border border-white/10 bg-gradient-to-b from-[#151e32] to-[#0d1424] p-8 text-center shadow-2xl">
        <XCircle className="mx-auto mb-4 h-12 w-12 text-slate-400" />
        <h1 className="font-disp text-3xl uppercase text-white" data-testid="payment-cancelled-heading">Checkout Cancelled</h1>
        <p className="mt-3 text-sm text-slate-400">
          No payment was taken and no booking was confirmed. Your fixed quote is waiting whenever you're ready.
        </p>
        <Link
          to="/#book"
          data-testid="retry-booking-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#38bdf8] px-6 py-3 text-xs font-bold uppercase tracking-wider text-[#0b101b] transition-colors hover:bg-white"
        >
          Return to Booking
        </Link>
      </div>
    </div>
  );
}
